import {
  ArrowOutwardRounded,
  CropFreeRounded,
  DragIndicatorRounded,
  InsertDriveFileRounded,
  Search as SearchIcon,
  TaskAltRounded,
} from '@mui/icons-material'
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogContent,
  DialogTitle,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { searchFieldSx } from '../../common/searchFieldSx'
import { useMutation } from 'react-query'
import { getReadableCustomerTemplateType } from '../../../domain/Customer/CustomerDisplay'
import { CustomersClient } from '../../../interactors/clients/CustomerClient'
import { CustomerDto, CustomerPdfTemplateDto, CustomerTemplateDto } from '../../../interactors/gen/backendClient'
import { CircularProgressPanel } from '../../common/CircularProgressPanel'
import { colors, spacingItem } from '../../theme'
import { AddPdfTemplateModal } from './CreatePdfTemplateModal'
import { PdfTemplateItem } from './PdfTemplateItem'

interface TemplatesListProps {
  association: CustomerDto
}

export const TemplatesList: React.FC<TemplatesListProps> = ({ association }) => {
  const [searchQuery, setSearchQuery] = useState('')
  const [isTutorialOpen, setIsTutorialOpen] = useState(false)
  const [_, setTemplatesList] = useState<CustomerTemplateDto[]>(association?.templates || [])
  const [pdfTemplatesList, setPdfTemplatesList] = useState<CustomerPdfTemplateDto[]>(association?.pdfTemplates || [])
  /* const navigate = useNavigate() */

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value)
  }

  /* const filteredTemplates = templatesList
    ? templatesList.filter(
        (template) =>
          searchQuery === '' ||
          template.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          getReadableCustomerTemplateType(template.type)?.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : [] */

  const filteredPdfTemplates = pdfTemplatesList
    ? pdfTemplatesList.filter(
        (template) =>
          searchQuery === '' ||
          template.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          getReadableCustomerTemplateType(template.type)?.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : []

  const fetchCustomerMutation = useMutation(async () => await CustomersClient.getCurrentCustomer(), {
    onSuccess: (data) => {
      setTemplatesList(data.templates || [])
      setPdfTemplatesList(data.pdfTemplates || [])
    },
  })

  useEffect(() => {
    fetchCustomerMutation.mutate()
  }, [])

  /* const handleSignatureClick = () => {
    navigate('/association/signature')
  } */

  /* const accountsStore = useAccountsStore() */
  /* const isAdmin = accountsStore.isAdmin() */
  /* const members = accountsStore.members */
  if (!association) return <CircularProgressPanel />
  /* const member = members.find((m) => m.id === association.signature?.madeBy) */

  return (
    <>
      {/* Signature Section */}
      {/* <Card sx={{ marginBottom: 2 }}>
        <CardHeader title="Signature" />
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            {association && association.signature ? (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                  p: 2,
                  border: '1px solid #ccc',
                  borderRadius: 2,
                  backgroundColor: '#f5f5f5',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <img
                    src={getCustomerSignatureSrc(association.signature.fileKey)}
                    alt="Signature"
                    style={{ maxHeight: '100px', maxWidth: '150px' }}
                  />
                  <Box>
                    <Typography variant="h6">Signature actuelle</Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                      <Typography variant="caption" color="text.secondary">
                        Mis en ligne le {new Date(association.signature.signedAt).toLocaleDateString('fr-FR')}
                      </Typography>
                      {member && (
                        <Typography variant="caption" color="text.secondary">
                          Par {fullName(member)}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Box>
                <IconButton
                  onClick={handleSignatureClick}
                  sx={{
                    '&:hover svg': {
                      color: 'black',
                    },
                  }}
                >
                  <Edit
                    sx={{
                      fontSize: 40,
                      color: 'grey',
                      transition: 'color 0.2s',
                    }}
                  />
                </IconButton>
              </Box>
            ) : (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                  p: 2,
                  border: '1px solid #ccc',
                  borderRadius: 2,
                  backgroundColor: '#f5f5f5',
                  cursor: 'pointer',
                  transition: 'transform 0.2s',
                  '&:hover': {
                    transform: 'scale(1.02)',
                  },
                }}
                onClick={handleSignatureClick}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Add fontSize="large" />
                  <Typography variant="h6">Ajouter une signature</Typography>
                </Box>
              </Box>
            )}
          </Box>
        </CardContent>
      </Card> */}

      {/* Templates Section */}
      <Box
        display="flex"
        flexDirection="row"
        flexWrap="nowrap"
        sx={{ ...spacingItem, mb: 2, backgroundColor: 'transparent' }}
      >
        <Box
          sx={{
            width: '100%',
            px: { xs: 1.5, md: 2 },
            py: { xs: 1.35, md: 1.6 },
            borderRadius: 3.5,
            border: '1px solid rgba(72, 146, 234, 0.14)',
            backgroundColor: 'rgba(214, 235, 255, 0.58)',
          }}
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1.25}
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            justifyContent="space-between"
          >
            <Box sx={{ maxWidth: { xs: '100%', sm: 660, md: 740 } }}>
              <Typography sx={{ color: colors.cello, fontSize: 13.5, fontWeight: 600 }}>
                Comment bien configurer ses documents en 3 étapes
              </Typography>
              <Typography
                component="div"
                sx={{
                  display: { xs: 'none', sm: 'block' },
                  mt: 0.45,
                  color: '#5F6B85',
                  fontSize: 12.2,
                  lineHeight: 1.45,
                }}
              >
                <Box
                  component="span"
                  sx={{
                    mr: 1,
                    color: colors.cello,
                    fontSize: 23,
                    lineHeight: 1,
                    fontWeight: 800,
                    display: 'inline-block',
                    transform: 'translateY(1px)',
                  }}
                >
                  ›
                </Box>
                Des procédures d&apos;adoption en un clic : génération, transmission et validation des documents depuis
                &quot;Adoptants&quot;.
              </Typography>
            </Box>

            <Button
              variant="text"
              onClick={() => setIsTutorialOpen(true)}
              sx={{
                textTransform: 'none',
                color: colors.cello,
                fontWeight: 700,
                px: 1.35,
                py: 0.55,
                minWidth: 0,
                borderRadius: '999px',
                border: '1px solid rgba(32, 56, 100, 0.12)',
                backgroundColor: 'rgba(255, 255, 255, 0.55)',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.8)',
                  borderColor: 'rgba(32, 56, 100, 0.18)',
                },
              }}
            >
              En savoir plus
            </Button>
          </Stack>
        </Box>
      </Box>
      <Card>
        <CardHeader title="Vos modèles de contrats et certificats" sx={{ pb: 1 }} />
        <CardContent sx={{ pt: 0 }}>
          <TextField
            id="name-input"
            placeholder="Rechercher un modèle"
            type="text"
            fullWidth
            value={searchQuery}
            onChange={handleSearch}
            sx={{ ...searchFieldSx, marginBottom: 2.5 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            {filteredPdfTemplates.length > 0 &&
              filteredPdfTemplates.map((template) => (
                <PdfTemplateItem key={template.id} template={template} setTemplatesList={setPdfTemplatesList} />
              ))}
          </Box>

          <Box display="flex" flexDirection="column" gap={2} alignItems="flex-end" sx={spacingItem}>
            <AddPdfTemplateModal />
          </Box>
        </CardContent>

        {/* <CardHeader title="Alternative au modèle PDF : créer vos modèles à partir de l’éditeur" sx={{ pb: 1 }} />
        <CardContent sx={{ pt: 0 }}>
          <Typography variant="body2" color="textSecondary" sx={{ marginBottom: 4, fontStyle: 'italic' }}>
            Créer votre modèle depuis un éditeur. Attention, cette alternative ne permet pas un haut degré de
            personnalisation graphique.
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 2, width: '100%' }}>
            <DefaultTemplateItem />
            {filteredTemplates.length > 0 &&
              filteredTemplates.map((template) => (
                <TemplateItem key={template.id} template={template} setTemplatesList={setTemplatesList} />
              ))}
          </Box>

          <Box display="flex" flexDirection="column" gap={2} alignItems="flex-end" sx={spacingItem}>
            <Tooltip title={isAdmin ? '' : 'Seuls les administrateurs peuvent ajouter des modèles'} arrow>
              <span>
                <Fab color="primary" variant="extended" onClick={() => navigate('/association/template')}>
                  <Add sx={{ mr: 1 }} />
                  Ajouter un modèle
                </Fab>
              </span>
            </Tooltip>
          </Box>
        </CardContent> */}
      </Card>

      <Dialog
        open={isTutorialOpen}
        onClose={() => setIsTutorialOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            width: { xs: '100%', md: 'min(1050px, calc(100% - 64px))' },
            maxWidth: { xs: 'calc(100% - 32px)', md: '1050px' },
          },
        }}
      >
        <DialogTitle
          sx={{
            pb: 1.2,
            color: colors.cello,
            fontWeight: 800,
            fontSize: { xs: 21, md: 25 },
          }}
        >
          Bien configurer ses documents en 3 étapes
        </DialogTitle>
        <DialogContent sx={{ pt: 1.2, pb: 2.8, px: { xs: 3, md: 3.5 } }}>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: 'repeat(3, minmax(0, 1fr))' },
              gap: { xs: 2, md: 2.25 },
            }}
          >
            {[
              {
                step: '1',
                title: '1. Importer votre modèle PDF',
                description: "Ajoutez un document propre, qui servira de base à toutes vos procédures d'adoption.",
                note: "Pensez à importer un document déjà signé par l'association pour servir de modèle signé.",
                illustration: (
                  <Box
                    sx={{
                      position: 'relative',
                      height: 92,
                      borderRadius: 3,
                      border: '1px dashed rgba(72, 146, 234, 0.4)',
                      backgroundColor: '#FFFFFF',
                      overflow: 'hidden',
                    }}
                  >
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 14,
                        left: 18,
                        width: 42,
                        height: 54,
                        borderRadius: 2,
                        border: '1px solid rgba(32, 56, 100, 0.12)',
                        backgroundColor: '#F8FAFF',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: colors.blueSky,
                      }}
                    >
                      <InsertDriveFileRounded sx={{ fontSize: 24 }} />
                    </Box>
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 28,
                        right: 18,
                        px: 1.25,
                        py: 0.6,
                        borderRadius: 99,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5,
                        color: colors.cello,
                        backgroundColor: 'rgba(214, 235, 255, 0.88)',
                      }}
                    >
                      <DragIndicatorRounded sx={{ fontSize: 16 }} />
                      <Typography sx={{ fontSize: 11.5, fontWeight: 600 }}>Glissez votre PDF</Typography>
                    </Box>
                  </Box>
                ),
              },
              {
                step: '2',
                title: '2. Définir les zones à remplir',
                description:
                  "Positionnez les zones de variables et de champs attendues par l'adoptant. Enregistrez et n'y touchez plus !",
                note: "Les zones variables reprennent les données de la fiche animal ; les zones champs seront à compléter par l'adoptant.",
                illustration: (
                  <Box
                    sx={{
                      position: 'relative',
                      height: 92,
                      borderRadius: 3,
                      backgroundColor: '#FFFFFF',
                      border: '1px solid rgba(32, 56, 100, 0.08)',
                      overflow: 'hidden',
                    }}
                  >
                    <Box
                      sx={{
                        position: 'absolute',
                        left: 24,
                        top: 20,
                        width: 96,
                        height: 48,
                        borderRadius: 2,
                        border: '2px dashed rgba(72, 146, 234, 0.45)',
                      }}
                    />
                    <Box
                      sx={{
                        position: 'absolute',
                        right: 18,
                        bottom: 16,
                        width: 26,
                        height: 26,
                        borderRadius: '50%',
                        backgroundColor: 'rgba(214, 235, 255, 0.95)',
                        border: '1px solid rgba(72, 146, 234, 0.28)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: colors.blueSky,
                      }}
                    >
                      <CropFreeRounded sx={{ fontSize: 16 }} />
                    </Box>
                    <Box
                      sx={{
                        position: 'absolute',
                        left: 108,
                        top: 54,
                        width: 54,
                        height: 2,
                        transform: 'rotate(-24deg)',
                        transformOrigin: 'left center',
                        backgroundColor: 'rgba(72, 146, 234, 0.5)',
                      }}
                    />
                  </Box>
                ),
              },
              {
                step: '3',
                title: '3. Réutiliser sans friction',
                description:
                  'Votre modèle peut être sélectionné dans les procédures pour générer et envoyer les documents en un clic.',
                note: "Certificat et contrat sont préparés ensemble. Le contrat peut ensuite être envoyé à signer depuis l'onglet Adoptants.",
                illustration: (
                  <Box
                    sx={{
                      position: 'relative',
                      height: 92,
                      borderRadius: 3,
                      background: 'linear-gradient(135deg, rgba(248,250,255,1) 0%, rgba(236,245,255,1) 100%)',
                      border: '1px solid rgba(32, 56, 100, 0.08)',
                      overflow: 'hidden',
                    }}
                  >
                    <Box
                      sx={{
                        position: 'absolute',
                        left: 18,
                        top: 18,
                        width: 44,
                        height: 56,
                        borderRadius: 2,
                        border: '1px solid rgba(32, 56, 100, 0.12)',
                        backgroundColor: '#FFFFFF',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: colors.cello,
                      }}
                    >
                      <InsertDriveFileRounded sx={{ fontSize: 24 }} />
                    </Box>
                    <Box
                      sx={{
                        position: 'absolute',
                        left: 74,
                        top: 34,
                        color: colors.blueSky,
                      }}
                    >
                      <ArrowOutwardRounded sx={{ fontSize: 24 }} />
                    </Box>
                    <Box
                      sx={{
                        position: 'absolute',
                        right: 18,
                        top: 25,
                        px: 1.2,
                        py: 0.75,
                        borderRadius: 99,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.65,
                        color: '#1F3764',
                        backgroundColor: '#FFFFFF',
                        border: '1px solid rgba(72, 146, 234, 0.16)',
                      }}
                    >
                      <TaskAltRounded sx={{ fontSize: 16, color: '#3F8F63' }} />
                      <Typography sx={{ fontSize: 11.5, fontWeight: 600 }}>Prêt à envoyer</Typography>
                    </Box>
                  </Box>
                ),
              },
            ].map((item) => (
              <Box
                key={item.step}
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  px: { xs: 1.5, md: 2 },
                  py: { xs: 1.6, md: 2 },
                  borderRadius: 3.5,
                  border: '1px solid rgba(32, 56, 100, 0.08)',
                  backgroundColor: '#F8FAFF',
                }}
              >
                <Typography
                  sx={{
                    order: { xs: 1, md: 2 },
                    mb: 0.75,
                    color: colors.cello,
                    fontWeight: 700,
                    fontSize: 16,
                    lineHeight: 1.25,
                  }}
                >
                  {item.title}
                </Typography>
                <Box sx={{ order: { xs: 2, md: 1 }, mb: { xs: 1.35, md: 1.55 } }}>{item.illustration}</Box>
                <Box sx={{ order: 3, minHeight: { xs: 'auto', md: 118 } }}>
                  <Typography sx={{ mb: 1.1, color: '#5F6B85', fontSize: 13.5, lineHeight: 1.6 }}>
                    {item.description}
                  </Typography>
                </Box>
                {item.note && (
                  <Box
                    sx={{
                      order: 4,
                      pt: 0.2,
                      px: 1.1,
                      py: 0.9,
                      borderRadius: 2.5,
                      backgroundColor: 'rgba(214, 235, 255, 0.42)',
                      border: '1px solid rgba(72, 146, 234, 0.12)',
                    }}
                  >
                    <Typography sx={{ color: colors.cello, fontSize: 11.4, fontWeight: 700, mb: 0.25 }}>
                      Astuce
                    </Typography>
                    <Typography sx={{ color: '#5F6B85', fontSize: 11.2, lineHeight: 1.55 }}>{item.note}</Typography>
                  </Box>
                )}
              </Box>
            ))}
          </Box>

          <Box sx={{ display: 'flex', justifyContent: { xs: 'stretch', sm: 'flex-end' }, mt: 2.5 }}>
            <Button
              variant="contained"
              onClick={() => setIsTutorialOpen(false)}
              sx={{
                textTransform: 'none',
                borderRadius: '999px',
                minHeight: 44,
                px: 3,
                fontWeight: 700,
                width: { xs: '100%', sm: 'fit-content' },
                boxShadow: 'none',
              }}
            >
              C&apos;est parti !
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  )
}
